import { LCLShipmentModel, QuoteManualDetailedModel, QuoteModel } from '@app/data-layer/models/lcl';
import { Selector } from '@ngxs/store';

import { LCLShippingStateModel } from './lcl-shipping-state.model';
import { LCLShippingState } from './lcl-shipping.state';
import { LclShipmentCardModel } from '@data-layer/models/lcl/lcl-shipment-card.model';
import { LclQuoteCardModel } from '@data-layer/models/lcl/lcl-quote-card.model';
import { enumShipmentState } from '@data-layer/enums/lcl';
import { enumLclTrackingStates } from '@enum/enumLclTrackingStates';
import { PaymentBillItemPendingModel } from '@data-layer/models/payments';

export class LCLShippingsSelectors {
  @Selector([LCLShippingState])
  public static isLoading(state: LCLShippingStateModel): boolean {
    return state?.isLoading;
  }

  @Selector([LCLShippingState])
  public static getPageLimit(state: LCLShippingStateModel): number {
    return state?.limit;
  }

  @Selector([LCLShippingState])
  public static getPageOffset(state: LCLShippingStateModel): number {
    return state?.offset;
  }

  @Selector([LCLShippingState])
  public static getTotal(state: LCLShippingStateModel): number {
    return state?.total;
  }

  @Selector([LCLShippingState])
  public static getLCLQuotes(state: LCLShippingStateModel): LclQuoteCardModel[] {
    return state?.quotes;
  }

  @Selector([LCLShippingState])
  public static getLCLManualQuotes(state: LCLShippingStateModel): QuoteManualDetailedModel[] {
    return state?.manualQuotes;
  }

  @Selector([LCLShippingState])
  public static getFilteredQuotesByExistingShipments(state: LCLShippingStateModel): LclQuoteCardModel[] {
    return (state?.quotes || []).filter((quote: LclQuoteCardModel) => !quote.shipmentId);
  }

  @Selector([LCLShippingState])
  public static getLCLShipments(state: LCLShippingStateModel): LclShipmentCardModel[] {
    return state?.shipments;
  }

  @Selector([LCLShippingState])
  public static isLCLShipmentsClosed(state: LCLShippingStateModel): boolean {
    return state?.shipments.every((shipment: LclShipmentCardModel) => {
      return shipment.state === enumShipmentState.CANCELED || shipment.trackingState === enumLclTrackingStates.DELIVERED;
    });
  }

  @Selector([LCLShippingState])
  public static getSelectedQuote(state: LCLShippingStateModel): QuoteModel {
    return state?.selectedQuote;
  }

  @Selector([LCLShippingState])
  public static getSelectedQuoteLCLPendingBills(state: LCLShippingStateModel): PaymentBillItemPendingModel {
    return state?.selectedQuoteLCLPayments;
  }

  @Selector([LCLShippingState])
  public static getSelectedShipment(state: LCLShippingStateModel): LCLShipmentModel {
    return state?.selectedShipment;
  }
}
